import React from 'react';
import { Button } from '../../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Trash2, AlertTriangle } from 'lucide-react';

export const DeleteEmployeeDialog = ({ 
  open, 
  onOpenChange, 
  employee, 
  hardDelete, 
  onHardDeleteChange,
  loading,
  onConfirm 
}) => {
  return (
    <Dialog open={open} onOpenChange={(open) => !loading && onOpenChange(open)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <Trash2 className="w-5 h-5" />
            Delete Employee
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete employee <strong>{employee?.employee_code}</strong> ({employee?.name || `${employee?.first_name} ${employee?.last_name}`})?
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="flex items-center gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
            <div className="text-sm text-amber-800">
              <p className="font-medium">Soft Delete (Recommended)</p>
              <p className="text-amber-600">Employee will be marked as deleted and can be restored later.</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="hardDelete"
              checked={hardDelete}
              onChange={(e) => onHardDeleteChange(e.target.checked)}
              className="rounded border-slate-300"
            />
            <label htmlFor="hardDelete" className="text-sm text-slate-700">
              Permanently delete (cannot be undone)
            </label>
          </div>
          {hardDelete && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-700">
                <strong>Warning:</strong> This will permanently remove the employee record and their user account. This action cannot be undone.
              </p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-delete"
          >
            {loading ? 'Deleting...' : (hardDelete ? 'Permanently Delete' : 'Delete')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteEmployeeDialog;
